// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"88629cdd","410":"da75554b","472":"059a4f93","485":"fdaa467d","823":"61c29da4"}[chunkId] + ".chunk.js";
};